import { render, staticRenderFns } from "./TableText.vue?vue&type=template&id=6f3a6064"
import script from "./TableText.vue?vue&type=script&lang=ts"
export * from "./TableText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports